import type { FlowProcess } from '@/features/flow/Flow';

export const installmentSteps = {
  PAYMENT: 'payment',
};

export const installmentOrder: FlowProcess[] = [
  {
    name: installmentSteps.PAYMENT,
    // isForwardSkip: ({ phone }) => Boolean(phone),
    // possibleBackwardTo: new Set([
    //   installmentSteps.STEP_1,
    //   installmentSteps.STEP_3,
    //   installmentSteps.STEP_4,
    // ]),
  },
];
